import gql from 'graphql-tag';

const viewerQuery = gql`
  query {
    viewer {
      user {
        id
        username
        roles
        firstName
        lastName
        email
      }
    }
  }
`;
export default viewerQuery;
